// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RakutenMobile from '../_raw/service/icon_rakuten_mobile.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RakutenMobile);
